import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the initial state type
interface FreeTrialState {
  isActive: boolean;
  isExpired: boolean;
  activatedAt: string | null; // dateTime stored as ISO string
}

// Retrieve initial state from localStorage
const localStorageKey = "__freeTrial";
const storedState = localStorage.getItem(localStorageKey);
const initialState: FreeTrialState = storedState
  ? JSON.parse(storedState)
  : {
      isActive: false,
      isExpired: false,
      activatedAt: null,
    };

if (!storedState) {
  localStorage.setItem(localStorageKey, JSON.stringify(initialState));
}

// Helper function to check if the trial is expired
// const checkIfExpired = (state: FreeTrialState): boolean => {
//   if (state.activatedAt) {
//     const activatedDate = new Date(state.activatedAt);
//     const currentDate = new Date();
//     const trialDurationDays = 7; // Assuming a 7-day free trial
//     const expirationDate = new Date(
//       activatedDate.getTime() + trialDurationDays * 24 * 60 * 60 * 1000
//     );

//     if (currentDate > expirationDate) {
//       state.isActive = false;
//       state.isExpired = true;
//       return true;
//     }
//     return false;
//   }
//   return false;
// };

// Create the slice
const freeTrialSlice = createSlice({
  name: "freeTrial",
  initialState,
  reducers: {
    activateFreeTrial(state) {
      state.isActive = true;
      state.isExpired = false;
      state.activatedAt = new Date().toISOString(); // Set to current ISO string dateTime
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    expireFreeTrial(state) {
      state.isActive = false;
      state.isExpired = true;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    resetFreeTrial(state) {
      state.isActive = false;
      state.isExpired = false;
      state.activatedAt = null;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
  },
});

// Export actions and reducer
export const { activateFreeTrial, expireFreeTrial, resetFreeTrial } =
  freeTrialSlice.actions;
export default freeTrialSlice.reducer;
